/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Error_Name_Country_RequiredInputs */



/**
* | output |
* | --- |
* | "Name and country are required" |
*
* @param {User_Error_Name_Country_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_error_name_country_required = /** @type {((inputs?: User_Error_Name_Country_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Error_Name_Country_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nom et le pays sont requis")
	if (locale === "es") return /** @type {LocalizedString} */ ("El nombre y el país son obligatorios")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome e país são obrigatórios")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome e nazione sono obbligatori")
	return /** @type {LocalizedString} */ ("Name and country are required")
});